<template>
	<div>
		validacion de email
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EmailValidation",
	beforeMount() {
		this.validate()
	},
	methods: {
		validate() {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($code: String!) {
							userVerifyEmailConfirm(code: $code)
						}
					`,
					variables: {
						code: this.$route.params.code
					}
				})
				.then((data) => {
					this.$router.push("/account/security")
				})
				.catch((err) => {
					this.parseGQLErrors(err)
				})
		}
	}
}
</script>
